import axios from 'axios'
import requesturl from '../requesturl'
import auth from "../auth";
import cookiemanager from "../managers/cookiemanager";

export default {

    async getRoleAppRights(roleId, roleAppRights) {
        let response = await axios.get(requesturl() + '/api/latest/Role/' + roleId + '/RoleAppRight',
            {headers: {Authorization: window.$cookies.get("token")}})
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
            });

        cookiemanager.updateCookies(response.headers);

        if (response.status === 204) {
            roleAppRights(null)
        } else {
            roleAppRights(response.data)
        }
    },

    async getRolePoolGroupRights(roleId, rolePoolGroupRights) {
        let response = await axios
            .get(requesturl() + '/api/latest/Role/' + roleId + '/RolePoolGroupRight',
                {headers: {Authorization: window.$cookies.get("token")}})
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
            });

        cookiemanager.updateCookies(response.headers);

        if (response.status === 204) {
            rolePoolGroupRights(null)
        } else {
            rolePoolGroupRights(response.data)
        }
    },

    async postRolePoolGroupRight(roleRight, response) {
        let headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': 'application/json'
        };

        await axios({
            method: 'post',
            url: requesturl() + '/api/latest/RolePoolGroupRight',
            headers: headers,
            data: JSON.stringify(roleRight)
        }).then(res => {
            cookiemanager.updateCookies(res.headers);
            let responseObj = {
                error: false,
                status: res.status
            };

            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };

            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }
            response(responseObj);
        });
    },

    async deleteRolePoolGroupRight(roleRight, response) {
        await axios.delete(requesturl() + "/api/latest/RolePoolGroupRight/" + roleRight.rolePoolGroupRightId,
            {headers: {Authorization: window.$cookies.get("token")}})
            .then((res) => {
                cookiemanager.updateCookies(res.headers);
                let responseObj = {
                    error: false,
                    status: res.status
                };

                response(responseObj);
            })
            .catch(error => {
                let responseObj = {
                    error: true,
                    status: error.response != null ? error.response.status : 503
                };
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
                response(responseObj);
            });
    },

    async postRoleAppRight(roleRight, response) {
        let headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': 'application/json'
        };

        await axios({
            method: 'post',
            url: requesturl() + '/api/latest/RoleAppRight',
            headers: headers,
            data: JSON.stringify(roleRight)
        }).then(res => {
            cookiemanager.updateCookies(res.headers);
            let responseObj = {
                error: false,
                status: res.status
            };

            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };

            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }
            response(responseObj);
        });
    },

    async deleteRoleAppRight(roleRight, response) {
        await axios.delete(requesturl() + "/api/latest/RoleAppRight/" + roleRight.roleAppRightId,
            {headers: {Authorization: window.$cookies.get("token")}})
            .then((res) => {
                cookiemanager.updateCookies(res.headers);
                let responseObj = {
                    error: false,
                    status: res.status
                };

                response(responseObj);
            }).catch(error => {
                let responseObj = {
                    error: true,
                    status: error.response != null ? error.response.status : 503
                };

                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
                response(responseObj);
            });
    }
}



// WEBPACK FOOTER //
// ./src/interfaces/rolerightinterface.js